import React from 'react';
import { useHasFF } from 'venn-utils';
import FactorForecasts from './components/FactorForecasts';
import MasterPortfolioSection from './components/MasterPortfolioSection';
import OrganizationCurrency from './components/OrganizationCurrency';
import PrintSettingsSection from './components/PrintSettingsSection';
import Integrations from './components/integrations/Integrations';
import Templates from './components/templates/Templates';
import type { UserProfileSettings } from 'venn-api';
import { Loading } from 'venn-ui-kit';
import AddeparIntegration from './components/integrations/AddeparIntegration';
import { ReportLabFontSizeDefaultsSection } from './components/ReportLabFontSizeDefaultsSection';

// TODO(VENN-24534): add a display name to this React component
// eslint-disable-next-line react/display-name
export default ({ profileSettings }: { profileSettings: UserProfileSettings }) => {
  const hasAddeparSelfService = useHasFF('addepar_self_service');
  const hasStudioReportEditor = useHasFF('studio_report_editor');
  const hasCustomFontSizes = useHasFF('custom_font_size_ff');

  return (
    <>
      <MasterPortfolioSection profileSettings={profileSettings} />
      <OrganizationCurrency profileSettings={profileSettings} />
      {hasStudioReportEditor && hasCustomFontSizes && <ReportLabFontSizeDefaultsSection />}
      {hasStudioReportEditor ? <PrintSettingsSection /> : null}
      <React.Suspense fallback={<Loading title="Forecasts are loading... " />}>
        <FactorForecasts />
      </React.Suspense>
      <Templates />
      {hasAddeparSelfService ? <AddeparIntegration /> : <Integrations />}
    </>
  );
};
